// Infers a listing's source from its heterogeneous shape, and whether that
// listing is external (a cold-agency / unclaimed listing whose poster is not a
// registered RxRooster group). Extracted from ProviderDiscoverPage so the swipe
// deck and the interview-request wizard share one definition of "external" —
// the wizard needs it to decide whether to ask the provider for intro consent.

/**
 * @param {object|null} listing
 * @returns {'internal'|'external'|'gaswork'|'unknown'}
 */
export function inferListingSource(listing) {
  if (!listing) return 'unknown';
  const t = listing._listingType || listing.sourceType;
  if (t === 'gaswork') return 'gaswork';
  if (t === 'external') return 'external';
  if (listing.section && !listing.facility) return 'external';
  return 'internal';
}

/**
 * True when the listing is external (poster is not a registered group), so a
 * provider expressing interest must consent to a direct introduction.
 * @param {object|null} listing
 * @returns {boolean}
 */
export function isExternalListing(listing) {
  const source = inferListingSource(listing);
  return source !== 'internal' && source !== 'unknown';
}
